<script>

import TwContainer from '@/components/generic/tw-container.vue'
import { useAuthStore } from '@/stores/auth.js'
import { mapActions, mapStores } from 'pinia'
import TwButton from '@/components/generic/tw-button.vue'
export default {
  name: 'TopLayoutNavigation',
  components: { TwButton, TwContainer },
  computed: {
    user() {
      return useAuthStore().user
    },
    previousUser() {
      return useAuthStore().previousUser
    }
  },
  methods:{
    ...mapActions(useAuthStore, ['logout','attempt_user','stopImpersonation']),
    logoutUser() {
      this.logout()
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    },
  }
}
</script>

<template>
  <Disclosure v-slot="{ open }" as="nav">
    <div class="bg-white drop-shadow-sm z-10 flex flex-col">
      <tw-container class="lg:hidden text-xs font-sans flex pt-3 justify-end">
        <div v-if="previousUser" class="text-orange-700">
          Hello {{ previousUser.name }}, Impersonating <router-link v-if="user" :to="{name: 'User'}" class="font-medium ml-[4px]">
            {{ user.name }}
          </router-link>
          <tw-button v-if="user" size="sm" variant="link" class="ml-5" @click="stopImpersonation">
            Logout
          </tw-button>
        </div>
        <div v-else>
          Logged in as <router-link v-if="user" :to="{name: 'User'}" class="font-medium ml-[4px]">
            {{ user.name }}
          </router-link>
          <tw-button v-if="user" size="sm" variant="link" class="ml-5" @click="logoutUser">
            Logout
          </tw-button>
        </div>
      </tw-container>
      <tw-container class="flex items-center justify-between pt-3 pb-4">
        <router-link :to="{ name: 'Home' }">
          <img class="h-10 md:h-12 w-auto md:min-w-[168px]" src="../../../img/logo.svg" alt="GroupRev Logo">
        </router-link>
        <div class="flex flex-col gap-5">
          <div class="flex place-content-end items-center">
            <div v-if="previousUser" class="hidden lg:flex text-xs font-sans bg-amber-200 px-2 py-1 rounded">
              Hello {{ previousUser.name }}, impersonating <router-link v-if="user" :to="{name: 'User'}" class="font-medium ml-[4px]">
                {{ user.name }}
              </router-link>
              <tw-button v-if="user" size="sm" variant="link" class="ml-5" @click="stopImpersonation">
                Logout
              </tw-button>
            </div>
            <div v-else class="hidden lg:flex text-xs font-sans ">
              Logged in as <router-link v-if="user" :to="{name: 'User'}" class="font-medium ml-[4px]">
                {{ user.name }}
              </router-link>
              <tw-button v-if="user" size="sm" variant="link" class="ml-5" @click="logoutUser">
                Logout
              </tw-button>
            </div>
            <!-- Mobile menu button-->
            <DisclosureButton class="lg:hidden inline-flex justify-center ml-4">
              <span class="sr-only">Open main menu</span>
              <Bars3Icon v-if="!open" class="block h-7 w-7" aria-hidden="true" />
              <XMarkIcon v-else class="block h-7 w-7" aria-hidden="true" />
            </DisclosureButton>
          </div>
          <div class="hidden lg:flex flex-wrap gap-5 md:gap-9 whitespace-nowrap font-sans capitalize text-sm">
            <router-link :to="{ name: 'DashboardPage' }" class="hover:text-blue-600">
              Dashboard
            </router-link>
            <router-link v-if="user && (user.role_organization || user.admin)" :to="{ name: 'FundraisersIndexPage'}" class="hover:text-blue-600">
              My {{ $t("Fundraiser",2) }}
            </router-link>
            <router-link :to="{name: 'MyFundraiserPagesIndexPage'}" class="hover:text-blue-600">
              My {{ $t("fundraiser_page",2) }}
            </router-link>
            <router-link :to="{name: 'DonationsIndexPage'}" class="hover:text-blue-600">
              Donations
            </router-link>
            <router-link v-if="user && (user.role_organization || user.admin)" :to="{name: 'OrganizationsIndexPage'}" class="hover:text-blue-600">
              {{ user.admin? 'Organizations':'Settings' }}
            </router-link>
            <router-link v-if="user && user.admin" :to="{name: 'support-requests-index-page'}" class="hover:text-blue-600">
              Support Requests
            </router-link>
            <router-link v-if="user && user.admin" :to="{name: 'send-email-notifications-to-organizations-page'}" class="hover:text-blue-600">
              Notify Organizations
            </router-link>
            <send-support-request-button v-if="user" class="hover:text-blue-600" @open-modal="$refs.supportModal.open()" />
          </div>
        </div>
      </tw-container>
      <DisclosurePanel class="lg:hidden text-white bg-gray-900 font-sans capitalize text-sm -mx-4 md:-mx-8 md:px-8 px-4 py-6">
        <tw-container>
          <div class="flex flex-col gap-5">
            <router-link :to="{ name: 'DashboardPage' }">
              Dashboard
            </router-link>
            <router-link v-if="user && (user.role_organization || user.admin)" :to="{ name: 'FundraisersIndexPage'}">
              My {{ $t("Fundraiser",2) }}
            </router-link>
            <router-link :to="{name: 'MyFundraiserPagesIndexPage'}">
              My {{ $t("fundraiser_page",2) }}
            </router-link>
            <router-link :to="{name: 'DonationsIndexPage'}">
              Donations
            </router-link>
            <router-link v-if="user && (user.role_organization || user.admin)" :to="{name: 'OrganizationsIndexPage'}">
              Settings
            </router-link>
          </div>
        </tw-container>
      </DisclosurePanel>
    </div>
  </Disclosure>
  <send-support-request-modal ref="supportModal" />
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import SendSupportRequestButton from '@/components/support-requests/send-support-request-button.vue'
import SendSupportRequestModal from '@/components/support-requests/send-support-request-modal.vue'
</script>

<style scoped>

</style>
